/** 
 * @description route level code-splitting
 * this generates a separate chunk ({routename}.[hash].js) for this route
 *  which is lazy-loaded when the route is visited
 * @example
 *  {
 *    path: '/routeexample',
 *    component: () => import('../views/RouteExample.vue'),
 *    meta: {
 *      requiresAuth: true,
 *    }
 *  }
 * @summary tldr: import with arrow function is a better use of resources
 * @exports Array array of objects, which define route names and their respective component
 */
export default [

  {
    path: '/',
    component: () => import('../views/tryNow/tryNow.vue'),
    props: true,
    meta: {
      requiresAuth: false,
    },  },
  {
    path: '/:partner',
    component: () => import('../views/tryNow/tryNow.vue'),
    props: true,
    meta: {
      requiresAuth: false,
    },
  }
]